/**
 * Класс для управления мобильным сайдбаром (баром) и оверлеем.
 * Поддерживает доступность (ARIA), блокировку скролла и управление через Esc.
 */
export class MobileSidebar {
    constructor(options = {}) {
        this.sidebarSelector = options.sidebarSelector || '.mobile-panel';
        this.layerSelector = options.layerSelector || '.mobile-panel-layer';
        this.toggleSelector = options.toggleSelector || '[data-toggle="mobile_bar"], [data-toggle="close_bar"], .side-menu__close';
        this.activeClass = options.activeClass || 'mobile-panel--active';
        this.layerActiveClass = options.layerActiveClass || 'mobile-panel-layer--active';

        this.initialized = false;

        // Переменные для свайпа
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.swipeThreshold = 70; // Минимальная дистанция для срабатывания свайпа (в пикселях)

        this.handleClicks = this.handleClicks.bind(this);
        this.handleEsc = this.handleEsc.bind(this);
        this.handleTouchStart = this.handleTouchStart.bind(this);
        this.handleTouchEnd = this.handleTouchEnd.bind(this);
    }

    init() {
        if (this.initialized) return;

        this.sidebar = document.querySelector(this.sidebarSelector);
        this.layer = document.querySelector(this.layerSelector);

        if (!this.sidebar) return;

        // Клики и клавиатура
        document.addEventListener('click', this.handleClicks);
        document.addEventListener('keydown', this.handleEsc);

        // Тач-события для свайпа (вешаем прямо на панель)
        this.sidebar.addEventListener('touchstart', this.handleTouchStart, { passive: true });
        this.sidebar.addEventListener('touchend', this.handleTouchEnd, { passive: true });

        this.initialized = true;
    }

    handleTouchStart(e) {
        this.touchStartX = e.changedTouches[0].screenX;
    }

    handleTouchEnd(e) {
        this.touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe();
    }

    handleSwipe() {
        // Если конечная точка X больше начальной — это свайп вправо
        const swipeDistance = this.touchEndX - this.touchStartX;

        if (swipeDistance > this.swipeThreshold) {
            console.log('[MobileSidebar]: Свайп вправо обнаружен');
            this.close();
        }
    }

    handleClicks(e) {
        const btn = e.target.closest(this.toggleSelector);
        if (btn) this.toggle(e, btn);

        if (this.layer && e.target === this.layer) {
            this.close();
        }
    }

    handleEsc(e) {
        if (e.key === 'Escape' && this.sidebar.classList.contains(this.activeClass)) {
            this.close();
        }
    }

    toggle(event, btn) {
        if (event) event.preventDefault();
        const isOpen = this.sidebar.classList.contains(this.activeClass);
        if (btn.dataset.toggle === 'close_bar' || btn.classList.contains('side-menu__close')) {
            this.close();
        } else {
            isOpen ? this.close() : this.open();
        }
    }

    open() {
        this.sidebar.classList.add(this.activeClass);
        if (this.layer) this.layer.classList.add(this.layerActiveClass);
        this.updateState(true);
    }

    close() {
        this.sidebar.classList.remove(this.activeClass);
        if (this.layer) this.layer.classList.remove(this.layerActiveClass);
        this.updateState(false);
    }

    updateState(isOpen) {
        document.body.style.overflow = isOpen ? 'hidden' : '';
        this.sidebar.setAttribute('aria-hidden', !isOpen);

        if (this.sidebar.id) {
            const buttons = document.querySelectorAll(`[aria-controls="${this.sidebar.id}"]`);
            buttons.forEach(btn => btn.setAttribute('aria-expanded', isOpen));
        }

        document.dispatchEvent(new CustomEvent('sidebar:toggle', {
            detail: { isOpen: isOpen, element: this.sidebar }
        }));
    }

    destroy() {
        document.removeEventListener('click', this.handleClicks);
        document.removeEventListener('keydown', this.handleEsc);
        this.sidebar.removeEventListener('touchstart', this.handleTouchStart);
        this.sidebar.removeEventListener('touchend', this.handleTouchEnd);
        this.initialized = false;
    }
}